export function MenuButton() {
  return (
    <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4 8.5463C4 8.38266 4.13266 8.25 4.2963 8.25H19.7037C19.8673 8.25 20 8.38266 20 8.5463V9.4537C20 9.61734 19.8673 9.75 19.7037 9.75H4.2963C4.13266 9.75 4 9.61734 4 9.4537V8.5463ZM4 11.5463C4 11.3827 4.13266 11.25 4.2963 11.25H19.7037C19.8673 11.25 20 11.3827 20 11.5463V12.4537C20 12.6173 19.8673 12.75 19.7037 12.75H4.2963C4.13266 12.75 4 12.6173 4 12.4537V11.5463ZM4.2963 14.25C4.13266 14.25 4 14.3827 4 14.5463V15.4537C4 15.6173 4.13266 15.75 4.2963 15.75H19.7037C19.8673 15.75 20 15.6173 20 15.4537V14.5463C20 14.3827 19.8673 14.25 19.7037 14.25H4.2963Z"
        fill="#333333"
      />
    </svg>
  );
}
